import { Component, Input } from '@angular/core';
import { NavItem } from '../../models/nav-item.model';

@Component({
  selector: 'app-menu-item-display-value',
  templateUrl: './menu-item-display-value.component.html',
  styleUrls: ['./menu-item-display-value.component.scss'],
})
export class MenuItemDisplayValueComponent {
  @Input({ required: true }) item!: NavItem;
}
